<ng-container *transloco="let t; read: 'user'">
  <div class="flex flex-col px-5 justify-center">
    @if (isAdd) {
      <drdp-title [title]="t('manageEnrollment.addViewEditChild.addNewChildTitle')" class="py-5"></drdp-title>
    }
    @if (isLoading) {
      <div></div>
    } @else {
      <drdp-container [additionClasses]="isAdd ? 'mx-auto flex p-8' : 'mx-auto shadow-none flex p-8'">
        <form [formGroup]="addChildForm">
          <h2 class="font-semibold text-lg">{{ t('manageEnrollment.addViewEditChild.sections.childInformation') }}</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            <div class="form-input-label-group">
              <label class="font-normal" for="firstName">{{ t('manageEnrollment.addViewEditChild.fields.firstName') }}<span class="required"></span></label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input [placeholder]="t('manageEnrollment.addViewEditChild.fields.firstName')" matInput [readonly]="isView" autocomplete="given-name" type="text"
                  formControlName="firstName" maxlength="50" required />
                @if (firstName.invalid) {
                  <mat-error>{{ required }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-input-label-group">
              <label class="font-normal" for="middleInitial">{{ t('manageEnrollment.addViewEditChild.fields.middleInitial') }}</label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input [placeholder]="t('manageEnrollment.addViewEditChild.fields.middleInitial')" matInput [readonly]="isView" autocomplete="off" type="text"
                  formControlName="middleInitial" maxlength="2" />
                @if (middleInitial.invalid && !isView) {
                  <mat-error>{{ t('manageEnrollment.addViewEditChild.errors.middleInitialLength') }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-input-label-group">
              <label class="font-normal" for="lastName">{{ t('manageEnrollment.addViewEditChild.fields.lastName') }}<span class="required"></span></label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input [placeholder]="t('manageEnrollment.addViewEditChild.fields.lastName')" matInput [readonly]="isView" autocomplete="family-name" type="text"
                  formControlName="lastName" maxlength="50" required />
                @if (lastName.invalid) {
                  <mat-error>{{ required }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-input-label-group">
              <label class="font-normal" for="SSID">
                {{ ssidLabel }}
                <span class="required"></span>
                <br />
                @if (isAdd) {
                  <span class="addl-instructions">
                    <span class="required"></span>
                  </span>
                }
              </label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input class="red-placeholder" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.ssidRequiredIfLocalIdBlank')" matInput [readonly]="isView"
                  autocomplete="off" type="text" formControlName="ssid" [maxlength]="ssidmaxLength" />
                @if (ssid.hasError('pattern') && !isView) {
                  <mat-error>{{ ssidPatternErrorMsg }}</mat-error>
                }
                @if (ssid.hasError('required') && !isView) {
                  <mat-error>{{ ssidLocalIdReqErrorMsg }}</mat-error>
                }
                @if (ssid.hasError('duplicateSSID') && !isView) {
                  <mat-error>{{ ssidErrorMsg }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-input-label-group">
              <label class="font-normal" for="localId">
                {{ agencySidLabel }}
                <span class="required"></span>
                <br />
                @if (isAdd) {
                  <span class="addl-instructions">
                    <span class="required"></span>
                  </span>
                }
              </label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input class="red-placeholder" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.localIdRequiredIfSsidBlank')" matInput [readonly]="isView"
                  autocomplete="off" type="text" formControlName="localId" maxlength="25" />
                @if (localId.hasError('required')) {
                  <mat-error>{{ ssidLocalIdReqErrorMsg }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-input-label-group">
              <label class="font-normal" for="drdpId">
                {{ t('manageEnrollment.addViewEditChild.fields.drdpId') }}
                <br />
              </label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input [placeholder]="t('manageEnrollment.addViewEditChild.fields.drdpId')" matInput autocomplete="off" type="text" formControlName="drdpId"
                  maxlength="25" readonly="" />
              </mat-form-field>
            </div>
            <div class="form-input-label-group">
              @if (isView) {
                <div class="bg-white removeLine" appearance="fill">
                  <label class="font-normal required" for="DOB">{{ t('manageEnrollment.addViewEditChild.fields.dob') }}</label>
                  <p class="text-sm">{{ dob?.value | localizedDate: "MM/dd/yyyy" }}</p>
                </div>
              }
              @if (!isView) {
                <div>
                  <drdp-date-picker [label]="t('manageEnrollment.addViewEditChild.fields.dob')" [initialDate]="dob?.value" [isReadOnly]="isView" [isRequired]="true"
                    (emitDate)="handleDate($event, 'dob')">
                  </drdp-date-picker>
                </div>
              }
            </div>
            @if (!isView) {
              <div>
                <drdp-select-age-grade #ageGroupInstrumentSelect [initialageGradeId]="ageGradeInstrumentId.value"
                  (ageGrade)="handleAgeGrade($event)" [stateId]="userStateId" [multiSelect]="false" [required]="true"
                  [label]="t('manageEnrollment.addViewEditChild.fields.ageGradeInstrument')" [tooltip]="ageGradeInstrumentWarning" [isPilot]="isUserState2025Enforced">
                </drdp-select-age-grade>
                @if (ageGradeInstrumentId.invalid) {
                  <mat-error class="absolute text-xs">{{ required }}</mat-error>
                }
              </div>
            }
            @if (isView) {
              <div class="self-start">
                <label class="font-normal" for="firstName">{{ t('manageEnrollment.addViewEditChild.fields.ageGradeInstrument') }}<span class="required"></span></label>
                <div class="bg-white removeLine" appearance="fill">
                  <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                  <p>{{ childData?.ageGradeInstrumentName }}</p>
                </div>
              </div>
            }
            <div>
              <label class="font-normal" for="socialEconomic">{{ t('manageEnrollment.addViewEditChild.fields.socioeconomicStatus') }}</label>
              <mat-checkbox [color]="'primary'" class="example-margin" formControlName="socialEconomic"
              [disabled]="!isAdd && !isEdit">{{ t('manageEnrollment.addViewEditChild.hints.socioeconomicCheckbox') }}</mat-checkbox>
            </div>
            @if (!isView) {
              <div>
                <div class="col-span-1 col-end-3">
                  <label class="font-normal" for="genderId">{{ t('manageEnrollment.addViewEditChild.fields.gender') }}<span class="required"></span></label>
                  <mat-radio-group [attr.aria-label]="t('manageEnrollment.addViewEditChild.common.selectAnOption')" formControlName="genderId">
                    <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                    @for (g of genders; track g) {
                      <mat-radio-button [color]="'primary'" [value]="g.id">
                        {{ g.genderName }}
                      </mat-radio-button>
                    }
                    @if (genderId.touched && genderId.invalid) {
                      <mat-error>{{ required }}</mat-error>
                    }
                  </mat-radio-group>
                </div>
              </div>
            }
            @if (isView) {
              <div class="form-input-label-group">
                <div class="col-span-1 col-end-3">
                  <label class="font-normal" for="firstName">{{ t('manageEnrollment.addViewEditChild.fields.gender') }}<span class="required"></span></label>
                  <div class="bg-white removeLine" appearance="fill">
                    <p>{{ childData?.genderName }}</p>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pt-4 md:pt-8">
            <!-- State-configured demographic fields: labels and options are server-supplied. -->
            @for (custom of customStateConfig | groupDemographicSection : demographicSections.childInformation; track custom) {
              <div class="form-input-label-group"
                >
                @if (isView) {
                  <div [id]="custom.label" class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">{{
                    custom.label }}</label>
                    <mat-form-field class="bg-white" ngClass="removeLine" appearance="fill">
                      <input matInput [readonly]="true" autocomplete="off" [formControlName]="custom.label" maxlength="10" />
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownSingle && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">{{
                    custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )">
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownMultiple && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">{{
                    custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )"
                        multiple>
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.text && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">{{
                    custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="text" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.number && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">{{
                    custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="number" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.date && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <drdp-date-picker [label]="custom.label" [initialDate]="addChildForm.get(custom.label)?.value"
                      [isReadOnly]="isView" [isRequired]="custom.isRequired"
                  (emitDate)="
                    buildCustomConfigObj(
                      custom.label,
                      custom.id,
                      custom.customFieldTypeId,
                      $event
                    )">
                    </drdp-date-picker>
                  </div>
                }
              </div>
            }
          </div>
            <hr class="my-5" />
            <h2 class="font-semibold text-lg">
              {{ t('manageEnrollment.addViewEditChild.sections.raceEthnicity') }}
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
              @if (!isView) {
                <div class="form-input-label-group">
                  <drdp-select-yes-no [label]="t('manageEnrollment.addViewEditChild.fields.hispanicOrLatino')" [initialId]="latino.value" [required]="true"
                    (optionSelected)="handleHispanic($event)" additionalClasses="pb-12">
                  </drdp-select-yes-no>
                  <div>
                    @if (latino.invalid) {
                      <mat-error class="absolute text-xs">{{ required }}</mat-error>
                    }
                  </div>
                </div>
              }
              @if (isView) {
                <div class="form-input-label-group">
                  <label class="font-normal required" for="latino">{{ t('manageEnrollment.addViewEditChild.fields.hispanicOrLatino') }}</label>
                  <mat-form-field class="bg-white removeLine" appearance="fill">
                    <input matInput readonly="true" [value]="childData.latino ? t('manageEnrollment.addViewEditChild.common.yes') : t('manageEnrollment.addViewEditChild.common.no')" type="text"
                      formControlName="latino" />
                  </mat-form-field>
                </div>
              }
              <div class="form-input-label-group">
              <label class="font-normal" for="ethnicities">
                {{ t('manageEnrollment.addViewEditChild.fields.race') }}
                <span class="required"></span>
                @if (!isView) {
                  <span class="addl-instructions">
                    {{ t('manageEnrollment.addViewEditChild.hints.raceInstructions') }}
                  </span>
                }
              </label>
              @if (!isView) {
                <mat-form-field appearance="fill" class="drdp-input">
                  <mat-select
                    formControlName="ethnicityIds"
                    multiple
                    [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.chooseAllThatApply')"
                    (selectionChange)="onEthnicityChange($event.value)">
                    <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                    @for (ethnicity of ethnicities; track ethnicity) {
                      <mat-option
                        [value]="ethnicity.id"
                        [disabled]="isEthnicityDisabled(ethnicity.id)">
                        @if (isNewHampshire) {
                          <span [matTooltip]="ethnicity.ethnicityName ?? ''">
                            {{ ethnicity.ethnicityName }}
                          </span>
                        }
                        @if (!isNewHampshire) {
                          <span>
                            {{ ethnicity.ethnicityName }}
                          </span>
                        }
                      </mat-option>
                    }
                  </mat-select>
                  @if (ethnicity.touched && ethnicity.invalid) {
                    <mat-error>{{ required }}</mat-error>
                  }
                </mat-form-field>
              }
              @if (isView && childData?.ethnicities) {
                <div>
                  <ul>
                    <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                    @for (ethnicity of childData?.ethnicities | option : ','; track ethnicity) {
                      <li>
                        {{ ethnicity }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pt-4 md:pt-8">
            <!-- State-configured demographic fields: labels and options are server-supplied. -->
            @for (custom of customStateConfig | groupDemographicSection : demographicSections.childRaceEthnicity; track custom) {
              <div class="form-input-label-group"
                >
                @if (isView) {
                  <div [id]="custom.label" class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" ngClass="removeLine" appearance="fill">
                      <input matInput [readonly]="true" autocomplete="off" [formControlName]="custom.label" maxlength="10" />
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownSingle && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )">
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownMultiple && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )"
                        multiple>
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.text && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="text" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.number && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="number" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.date && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <drdp-date-picker [label]="custom.label" [initialDate]="addChildForm.get(custom.label)?.value"
                      [isReadOnly]="isView" [isRequired]="custom.isRequired"
                  (emitDate)="
                    buildCustomConfigObj(
                      custom.label,
                      custom.id,
                      custom.customFieldTypeId,
                      $event
                    )">
                    </drdp-date-picker>
                  </div>
                }
              </div>
            }
          </div>
          <hr class="my-5" />
          <h2 class="font-semibold text-lg">{{ t('manageEnrollment.addViewEditChild.sections.languageInformation') }}</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            <div class="form-input-label-group">
              <label class="font-normal" for="languages">{{ t('manageEnrollment.addViewEditChild.fields.homeLanguage') }}<span
              class="required"></span></label>
              @if (!isView) {
                <mat-form-field appearance="fill" id="languageSelect" class="drdp-input">
                  <mat-select formControlName="languageIds" multiple [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.chooseAllThatApply')">
                    <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                    @for (language of languagesList; track language) {
                      <mat-option [value]="language.id">
                        {{ language.languageName }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (languageIds.invalid) {
                    <mat-error>{{ required }}</mat-error>
                  }
                </mat-form-field>
              }
              @if (isView && childData?.languages.length > 1) {
                <div>
                  <ul>
                    <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                    @for (language of childData?.languages | option : ','; track language) {
                      <li>
                        {{ language }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
            <div class="form-input-label-group">
              @if (!isView) {
                <div>
                  <drdp-select-yes-no [label]="t('manageEnrollment.addViewEditChild.fields.otherLanguageAtHome')"
                    [initialId]="eld.value" [required]="true" (optionSelected)="handleEld($event)">
                  </drdp-select-yes-no>
                  @if (eld.invalid) {
                    <mat-error class="absolute text-xs">{{ required }}</mat-error>
                  }
                </div>
              }
              @if (isView) {
                <mat-form-field class="bg-white removeLine" appearance="fill">
                  <label class="font-normal mt-0" for="eld">
                    {{ t('manageEnrollment.addViewEditChild.fields.otherLanguageAtHome') }}
                    <span class="required"></span>
                  </label>
                  <input matInput readonly="true" [value]="childData?.eld" type="text" formControlName="eld" required />
                </mat-form-field>
              }
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pt-4 md:pt-8">
            <!-- State-configured demographic fields: labels and options are server-supplied. -->
            @for (custom of customStateConfig | groupDemographicSection : demographicSections.childLanguageInfo; track custom) {
              <div class="form-input-label-group"
                >
                @if (isView) {
                  <div [id]="custom.label" class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" ngClass="removeLine" appearance="fill">
                      <input matInput [readonly]="true" autocomplete="off" [formControlName]="custom.label" maxlength="10" />
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownSingle && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )">
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownMultiple && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )"
                        multiple>
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.text && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="text" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.number && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="number" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.date && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <drdp-date-picker [label]="custom.label" [initialDate]="addChildForm.get(custom.label)?.value"
                      [isReadOnly]="isView" [isRequired]="custom.isRequired"
                  (emitDate)="
                    buildCustomConfigObj(
                      custom.label,
                      custom.id,
                      custom.customFieldTypeId,
                      $event
                    )">
                    </drdp-date-picker>
                  </div>
                }
              </div>
            }
          </div>
          <hr class="my-5" />
          <h2 class="font-semibold text-lg">{{ t('manageEnrollment.addViewEditChild.sections.programInformation') }}</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
            <div class="form-input-label-group">
              <label class="font-normal required" for="enrollmentPrograms">{{ t('manageEnrollment.addViewEditChild.fields.programType') }}</label>
              @if (!isView) {
                <mat-form-field appearance="fill" id="programSelect" class="drdp-input">
                  <mat-select formControlName="enrollmentProgramIds" [placeholder]="enrollmentProgramPlaceholder"
                    required="true" multiple>
                    <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                    @for (ept of enrollmentProgramTypesFiltered ?? enrollmentProgramTypes; track ept) {
                      <mat-option [value]="ept.enrollmentProgramId">
                        {{ ept.enrollmentProgramType?.enrollmentProgramName }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (enrollmentProgramIds.invalid) {
                    <mat-error>{{ required }}</mat-error>
                  }
                </mat-form-field>
              }
              @if (isView && childData?.enrollmentProgramNames.length > 1) {
                <div>
                  <ul>
                    <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                    @for (ep of childData?.enrollmentProgramNames | option : ','; track ep) {
                      <li>
                        {{ ep }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
            <div class="form-input-label-group">
              @if (otherRequired || other?.value?.length > 1) {
                <div>
                  <label class="font-normal" for="other">{{ t('manageEnrollment.addViewEditChild.fields.other') }}<span class="required"></span></label>
                  <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                    <input matInput type="text" formControlName="other" palceholder="Other" maxlength="50"/>
                    @if (other.invalid) {
                      <mat-error>{{ t('manageEnrollment.addViewEditChild.errors.otherProgramRequired') }}</mat-error>
                    }
                  </mat-form-field>
                </div>
              }
            </div>
            <div class="self-end hidden md:block"></div>
            <div class="relative">
              <div class="form-input-label-group">
                @if (isView) {
                  <div class="bg-white removeLine" appearance="fill">
                    <label class="font-normal required" for="Agency Enrollment Date">{{ t('manageEnrollment.addViewEditChild.fields.agencyEnrollmentDate') }}</label>
                    <p class="text-sm">
                      {{ enrollmentStartDate.value | localizedDate: "MM/dd/yyyy" }}
                    </p>
                  </div>
                }
                @if (!isView) {
                  <div>
                    <drdp-date-picker [label]="t('manageEnrollment.addViewEditChild.fields.agencyEnrollmentDate')" [initialDate]="enrollmentStartDate.value"
                      [isReadOnly]="isView" [isRequired]="true" (emitDate)="handleDate($event, 'enrollmentStartDate')">
                    </drdp-date-picker>
                  </div>
                }
              </div>
              @if (!isView) {
                <div class="absolute top-0 left-full mt-2 ml-[-2px]">
                  <i class="uil uil-info-circle text-xs" [matTooltip]=agencyEnrollmentInfo></i>
                </div>
              }
            </div>
            <div class="form-input-label-group">
              <label class="font-normal" for="enrollmentEndDate">
                {{ t('manageEnrollment.addViewEditChild.fields.agencyWithdrawalDate') }}
                @if (!isView) {
                  <i class="uil uil-info-circle text-xs" [matTooltip]=withdrawlInfo></i>
                }
              </label>
              <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                <input matInput readonly=true type="text" [value]="enrollmentEndDate.value | localizedDate:'MM/dd/yyyy'" />
              </mat-form-field>
            </div>
            <div class="self-end hidden md:block"></div>
            <div class="form-input-label-group">
              @if (!isView) {
                <div>
                  <drdp-select-county (county)="handleChosenCountyOfProgram($event)"
                    [initialCountyIds]="countyOfProgramId.value" [stateId]="userStateId" [multiSelect]="false"
                    [label]="t('manageEnrollment.addViewEditChild.fields.countyOfProgram')" [multiSelect]="false">
                  </drdp-select-county>
                </div>
              }
              @if (isView) {
                <div class="bg-white removeLine" appearance="fill">
                  <label class="font-normal" for="countyOfProgram">{{ t('manageEnrollment.addViewEditChild.fields.countyOfProgram') }}</label>
                  <p>{{ chosenCountyOfProgram }}</p>
                </div>
              }
            </div>
            <div class="form-input-label-group">
              @if (!isView) {
                <div>
                  <drdp-select-county (county)="handleChosenCountyOfResidence($event)"
                    [initialCountyIds]="countyOfResidenceId.value" [stateId]="userStateId" [multiSelect]="false"
                    [label]="t('manageEnrollment.addViewEditChild.fields.countyOfResidence')" [multiSelect]="false">
                  </drdp-select-county>
                </div>
              }
              @if (isView) {
                <div class="bg-white removeLine" appearance="fill">
                  <label class="font-normal" for="countyOfResidence">{{ t('manageEnrollment.addViewEditChild.fields.countyOfResidence') }}</label>
                  <p>{{ chosenCountyOfResidence }}</p>
                </div>
              }
            </div>
            <div class="self-end hidden md:block"></div>
            <div class="self-end md:col-span-2">
              <label class="font-normal" for="tuitionFeeId">{{ t('manageEnrollment.addViewEditChild.fields.tuitionFees') }}</label>
              @if (!isView) {
                <mat-checkbox-group [attr.aria-label]="t('manageEnrollment.addViewEditChild.common.selectAnOption')" class="flex flex-col">
                  <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                  @for (tf of tuitionFee; track tf) {
                    <mat-checkbox class="rounded-checkboxes mb-3" [color]="'primary'" [checked]="tuitionFeeId.value == tf.id"
                      (change)="deselectCheck(tf.id)">
                      {{ tf.tuitionFeeName }}
                    </mat-checkbox>
                  }
                </mat-checkbox-group>
              }
              @if (isView) {
                <div class="bg-white removeLine" appearance="fill">
                  <p>{{ childData?.tuitionFeeName }}</p>
                </div>
              }
            </div>
            <div class="self-end hidden md:block"></div>
            @if (canViewDualInfo) {
              <div class="self-end md:col-span-1">
                <label class="font-normal" for="enrollmentPrograms">{{ t('manageEnrollment.addViewEditChild.fields.dualEnrollmentProgram') }}</label>
                @if (!isView) {
                  <mat-form-field appearance="fill" id="programSelect" class="drdp-input">
                    <mat-select formControlName="dualEnrollmentProgramIds" [placeholder]="enrollmentProgramPlaceholder"
                      multiple>
                      <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                      @for (ept of enrollmentProgramTypesFiltered ?? enrollmentProgramTypes; track ept) {
                        <mat-option
                          [value]="ept.enrollmentProgramId">
                          {{ ept.enrollmentProgramType?.enrollmentProgramName }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (isView && childData?.dualEnrollmentProgramNames) {
                  <div>
                    <ul>
                      <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                      @for (ep of childData?.dualEnrollmentProgramNames | option : ','; track ep) {
                        <li>
                          {{ ep }}
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
            @if (canViewDualInfo) {
              <div>
                <div class="form-input-label-group">
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="Dual Agency Enrollment Date">{{ t('manageEnrollment.addViewEditChild.fields.dualAgencyEnrollmentDate') }}
                        <!-- <i *ngIf="!isView" class="uil uil-info-circle text-xs" [matTooltip]=agencyEnrollmentInfo></i> -->
                      </label>
                      <p class="text-sm">
                        {{ dualEnrollmentStartDate.value | localizedDate: "MM/dd/yyyy" }}
                      </p>
                    </div>
                  }
                  @if (!isView) {
                    <div>
                      <drdp-date-picker class="pt-3" [label]="t('manageEnrollment.addViewEditChild.fields.dualAgencyEnrollmentDate')" [initialDate]="dualEnrollmentStartDate.value"
                        [isReadOnly]="isView" [isRequired]="false" (emitDate)="handleDate($event, 'dualEnrollmentStartDate')">
                      </drdp-date-picker>
                    </div>
                  }
                </div>
              </div>
            }
            @if (canViewDualInfo) {
              <div class="form-input-label-group">
                <label class="font-normal" for="dualEnrollmentEndDate">
                  {{ t('manageEnrollment.addViewEditChild.fields.dualAgencyWithdrawalDate') }}
                  <!-- <i *ngIf="!isView" class="uil uil-info-circle text-xs" [matTooltip]=withdrawlInfo></i> -->
                </label>
                <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                  <input matInput readonly=true type="text" [value]="dualEnrollmentEndDate.value | localizedDate:'MM/dd/yyyy'" />
                </mat-form-field>
              </div>
            }
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pt-4 md:pt-8">
            <!-- State-configured demographic fields: labels and options are server-supplied. -->
            @for (custom of customStateConfig | groupDemographicSection : demographicSections.childProgramInfo; track custom) {
              <div class="form-input-label-group"
                >
                @if (isView) {
                  <div [id]="custom.label" class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" ngClass="removeLine" appearance="fill">
                      <input matInput [readonly]="true" autocomplete="off" [formControlName]="custom.label" maxlength="10" />
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownSingle && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )">
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownMultiple && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )"
                        multiple>
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.text && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="text" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.number && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="number" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.date && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <drdp-date-picker [label]="custom.label" [initialDate]="addChildForm.get(custom.label)?.value"
                      [isReadOnly]="isView" [isRequired]="custom.isRequired"
                  (emitDate)="
                    buildCustomConfigObj(
                      custom.label,
                      custom.id,
                      custom.customFieldTypeId,
                      $event
                    )">
                    </drdp-date-picker>
                  </div>
                }
              </div>
            }
          </div>
          @if (displaySpecialEd || (enrollDroppedChild && !isNewHampshire)) {
            <div>
              <hr class="my-5" />
              <h2 class="font-semibold text-lg">{{ t('manageEnrollment.addViewEditChild.sections.specialEducation') }}
              </h2>
              <div
                class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pb-4 md:pb-8">
                @if (displaySpecialEd || (enrollDroppedChild && !isNewHampshire)) {
                  <div [ngClass]="{ 'form-input-label-group': !isView }">
                    @if (isView) {
                      <label class="font-normal required" for="iepPlanId">
                        {{ t('manageEnrollment.addViewEditChild.fields.iepOrIfsp') }}
                      </label>
                    }
                    @if (!isView) {
                      <div>
                        <drdp-select-iep-plan [initialId]="iepPlanId.value" [required]="true"
                          (optionSelected)="handleIep($event, true)">
                        </drdp-select-iep-plan>
                        @if (iepPlanId.invalid) {
                          <mat-error class="absolute text-xs">{{ required }}</mat-error>
                        }
                      </div>
                    }
                    @if (isView) {
                      <mat-form-field appearance="fill" class="bg-white removeLine">
                        <input matInput readonly="true" [value]="childData?.iepPlanName" type="text"
                          formControlName="iepPlanId" />
                      </mat-form-field>
                    }
                  </div>
                }
                @if (displaySpecialEd) {
                  <ng-container>
                    @if (specialEdInfo.isPrimaryDisabilityEnabled) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="primaryDisabilityId">{{ t('manageEnrollment.addViewEditChild.fields.primaryDisability') }}</label>
                      @if (!isView) {
                        <mat-form-field appearance="fill" id="primaryDisabilitySelect" class="drdp-input">
                          <mat-select formControlName="primaryDisabilityId" [placeholder]="t('manageEnrollment.addViewEditChild.fields.primaryDisability')">
                            <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                            @for (disability of disabilities; track disability) {
                              <mat-option [value]="disability.id">
                                {{ disability.primaryDisabilityName }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <p>{{ childData?.primaryDisabilityName }}</p>
                        </div>
                      }
                    </div>
                  }
                  @if (isNewHampshire && specialEdInfo.isDistrictLiabilityEnabled) {
                    <div class="self-end hidden md:block">
                    </div>
                  }
                  @if (specialEdInfo.isDistrictLiabilityEnabled) {
                    <div class="form-input-label-group">
                      <label class="font-normal" for="districtOfLiabilityId"
                      [ngClass]="{'required': isDistrictLiabilityRequired}">{{ t('manageEnrollment.addViewEditChild.fields.districtOfLiability') }}</label>
                      @if (!isView) {
                        <mat-form-field appearance="fill" id="liabilitySelect" class="drdp-input">
                          <mat-select formControlName="districtOfLiabilityId" [placeholder]="t('manageEnrollment.addViewEditChild.fields.districtOfLiability')">
                            <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                            @for (dol of districtsOfLiability; track dol) {
                              <mat-option [value]="dol.id">
                                {{ dol.districtOfLiabilityName }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (districtOfLiabilityId.invalid) {
                            <mat-error>{{ required }}</mat-error>
                          }
                        </mat-form-field>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <p>{{ childData?.districtOfLiabilityName }}</p>
                        </div>
                      }
                    </div>
                  }
                  @if (isNewHampshire && specialEdInfo.isDistrictLiabilityEnabled) {
                    <div class="form-input-label-group">
                      <label class="font-normal">{{ t('manageEnrollment.addViewEditChild.fields.districtId') }}</label>
                      <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                        <input [placeholder]="t('manageEnrollment.addViewEditChild.fields.districtId')" matInput type="text" [value]="districtId" [readonly]="true" />
                      </mat-form-field>
                    </div>
                  }
                  @if (isNewHampshire && specialEdInfo.isDistrictLiabilityEnabled) {
                    <div class="form-input-label-group">
                      <label class="font-normal">{{ t('manageEnrollment.addViewEditChild.fields.sauId') }}</label>
                      <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                        <input [placeholder]="t('manageEnrollment.addViewEditChild.fields.sauId')" matInput type="text" [value]="sauId" readonly="true" />
                      </mat-form-field>
                    </div>
                  }
                  @if (specialEdInfo.isSelpaEnabled) {
                    <div class="form-input-label-group">
                      @if (!isView) {
                        <div>
                          <drdp-select-selpa (selpa)="handleChosenSelpa($event, true)" [initialSelpaId]="selpaId.value"
                            additionalClasses="pb-12">
                          </drdp-select-selpa>
                        </div>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal pb-14" for="selpa">{{ t('manageEnrollment.addViewEditChild.fields.selpas') }}</label>
                          <p>{{ childData?.selpaName }}</p>
                        </div>
                      }
                    </div>
                  }
                  <div class="form-input-label-group">
                    <label class="font-normal" for="adaptations">{{ t('manageEnrollment.addViewEditChild.fields.adaptations') }}</label>
                    @if (!isView) {
                      <mat-form-field appearance="fill" id="adaptationSelect" class="drdp-input">
                        <mat-select formControlName="adaptationIds" multiple [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.chooseAllThatApply')">
                          <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                          @for (adaptation of adaptations; track adaptation) {
                            <mat-option [value]="adaptation.id">{{
                              adaptation.adaptationTypeName }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (isView && childData?.adaptations.length > 1) {
                      <div>
                        <ul>
                          <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                          @for (adaptation of childData?.adaptations | option : ','; track adaptation) {
                            <li>
                              {{ adaptation }}
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                  @if (specialEdInfo.isSpecialEdEntryEnabled) {
                    <div class="form-input-label-group">
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal" for="seEntryDate">{{ t('manageEnrollment.addViewEditChild.fields.specialEdEntryDate') }}</label>
                          <p class="text-sm">
                            {{ seEntryDate?.value | localizedDate: "MM/dd/yyyy" }}
                          </p>
                        </div>
                      }
                      @if (!isView) {
                        <div>
                          <drdp-date-picker
                            [label]="t('manageEnrollment.addViewEditChild.fields.specialEdEntryDate')"
                            [initialDate]="seEntryDate?.value"
                            [isReadOnly]="isView"
                            [isRequired]="iepPlanId.value == iepPlan.Yes"
                            labelClasses="pb-10 mb-5"
                            (emitDate)="handleDate($event, 'seEntryDate')"
                            >
                          </drdp-date-picker>
                        </div>
                      }
                    </div>
                  }
                  @if (specialEdInfo.isAnticipatedDateEnabled) {
                    <div class="form-input-label-group">
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal" for="seAnticipateExitDate">{{ t('manageEnrollment.addViewEditChild.fields.specialEdAnticipatedExitDate') }}</label>
                          <p class="text-sm">
                            {{ seAnticipateExitDate?.value | localizedDate: "MM/dd/yyyy" }}
                          </p>
                        </div>
                      }
                      @if (!isView) {
                        <div>
                          <drdp-date-picker [label]="t('manageEnrollment.addViewEditChild.fields.specialEdAnticipatedExitDate')"
                            [initialDate]="seAnticipateExitDate.value" [isReadOnly]="isView" labelClasses="pb-5 mb-5"
                            (emitDate)="handleDate($event, 'seAnticipateExitDate')">
                          </drdp-date-picker>
                        </div>
                      }
                    </div>
                  }
                  @if (specialEdInfo?.isSpecialEdExitEnabled) {
                    <div
                      class="form-input-label-group"
                      >
                      <div class="bg-white" appearance="fill">
                        <label class="font-normal" for="seExitDate">
                          {{ t('manageEnrollment.addViewEditChild.fields.specialEdExitDate') }}
                          @if (!isView) {
                            <i class="uil uil-info-circle text-xs" [matTooltip]="specialEdExitInfo"></i>
                          }
                        </label>
                        <mat-form-field
                          class="bg-white"
                          [ngClass]="{ removeLine: isView, 'pt-10': !isView }"
                          appearance="fill"
                          >
                          <input
                            matInput
                            readonly=true
                            type="text"
                            [value]="seExitDate.value | localizedDate:'MM/dd/yyyy'"
                            />
                        </mat-form-field>
                      </div>
                    </div>
                  }
                  @if (specialEdInfo.isInitialAssessmentToolEnabled) {
                    <div
                      class="form-input-label-group"
                      >
                      @if (!isView) {
                        <div>
                          <drdp-select-initial-assessment-tool-type [label]="t('manageEnrollment.addViewEditChild.fields.initialAssessmentTool')"
                            [initialId]="initialAssessmentToolId?.value"
                            (optionSelected)="handleInitAssessment($event, 'initialAssessmentToolId')">
                          </drdp-select-initial-assessment-tool-type>
                        </div>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal" for="initialAssessmentTool">{{ t('manageEnrollment.addViewEditChild.fields.initialAssessmentTool') }}</label>
                          <p class="text-sm">{{ childData?.initialAssessmentToolTypeName }}</p>
                        </div>
                      }
                    </div>
                  }
                  @if (specialEdInfo.isOutcome1Enabled) {
                    <div class="form-input-label-group">
                      @if (!isView) {
                        <div>
                          <drdp-select-outcome [label]="t('manageEnrollment.addViewEditChild.fields.outcome1')" [initialId]="outcome1Id?.value"
                            (optionSelected)="handleOutcome($event, 'outcome1Id')">
                          </drdp-select-outcome>
                        </div>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal" for="outcome1">{{ t('manageEnrollment.addViewEditChild.fields.outcome1') }}</label>
                          <p class="text-sm">{{ childData?.outcome1Name }}</p>
                        </div>
                      }
                    </div>
                  }
                  @if (specialEdInfo.isOutcome2Enabled) {
                    <div class="form-input-label-group">
                      @if (!isView) {
                        <div>
                          <drdp-select-outcome [label]="t('manageEnrollment.addViewEditChild.fields.outcome2')" [initialId]="outcome2Id?.value"
                            (optionSelected)="handleOutcome($event, 'outcome2Id')">
                          </drdp-select-outcome>
                        </div>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal" for="outcome2">{{ t('manageEnrollment.addViewEditChild.fields.outcome2') }}</label>
                          <p class="text-sm">{{ childData?.outcome2Name }}</p>
                        </div>
                      }
                    </div>
                  }
                  @if (specialEdInfo.isOutcome3Enabled) {
                    <div class="form-input-label-group">
                      @if (!isView) {
                        <div>
                          <drdp-select-outcome [label]="t('manageEnrollment.addViewEditChild.fields.outcome3')" [initialId]="outcome3Id?.value"
                            (optionSelected)="handleOutcome($event, 'outcome3Id')">
                          </drdp-select-outcome>
                        </div>
                      }
                      @if (isView) {
                        <div class="bg-white removeLine" appearance="fill">
                          <label class="font-normal" for="outcome3">{{ t('manageEnrollment.addViewEditChild.fields.outcome3') }}</label>
                          <p class="text-sm">{{ childData?.outcome3Name }}</p>
                        </div>
                      }
                    </div>
                  }
                </ng-container>
                }
              </div>
            </div>
          }
          @if (canViewDualInfo) {
            <h2 class="font-semibold text-lg">
            {{ t('manageEnrollment.addViewEditChild.sections.dualSpecialEducation') }}</h2>
          }
          @if (canViewDualInfo) {
            <div
              class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pb-4 md:pb-8">
              <div [ngClass]="{ 'form-input-label-group': !isView }">
                @if (isView) {
                  <label class="font-normal required" for="iepPlanId">
                    {{ t('manageEnrollment.addViewEditChild.fields.iepOrIfsp') }}
                  </label>
                }
                @if (!isView) {
                  <div>
                    <drdp-select-iep-plan [initialId]="dualIepPlanId.value" [required]="true"
                      (optionSelected)="handleIep($event, false)">
                    </drdp-select-iep-plan>
                  </div>
                }
                @if (isView) {
                  <mat-form-field appearance="fill" class="bg-white removeLine">
                    <input matInput readonly="true" [value]="childData?.dualEnrollmentIepPlanName" type="text"
                      formControlName="dualIepPlanId" />
                  </mat-form-field>
                }
              </div>
              @if (specialEdInfo.isSelpaEnabled && !specialEdInfo.isPrimaryDisabilityEnabled) {
                <div class="form-input-label-group"
                  >
                  @if (!isView) {
                    <div>
                      <drdp-select-selpa (selpa)="handleChosenSelpa($event, false)" [initialSelpaId]="dualSelpaId.value"
                        additionalClasses="pb-12">
                      </drdp-select-selpa>
                    </div>
                  }
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal pb-14" for="selpa">{{ t('manageEnrollment.addViewEditChild.fields.selpas') }}</label>
                      <p>{{ childData?.dualEnrollmentSelpaName }}</p>
                    </div>
                  }
                </div>
              }
              <div class="form-input-label-group">
                <label class="font-normal" for="adaptations">{{ t('manageEnrollment.addViewEditChild.fields.adaptations') }}</label>
                @if (!isView) {
                  <mat-form-field appearance="fill" id="adaptationSelect" class="drdp-input">
                    <mat-select formControlName="dualAdaptationIds" multiple [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.chooseAllThatApply')">
                      <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                      @for (adaptation of adaptations; track adaptation) {
                        <mat-option [value]="adaptation.id">
                          {{ adaptation.adaptationTypeName }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (isView && childData?.dualAdaptations) {
                  <div>
                    <ul>
                      <!-- Server-supplied child data: localized by the API, not by Transloco. -->
                      @for (adaptation of childData?.dualAdaptations | option : ','; track adaptation) {
                        <li>
                          {{ adaptation }}
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
              @if (specialEdInfo.isPrimaryDisabilityEnabled || primaryDisabilityReq) {
                <div class="form-input-label-group">
                  <label class="font-normal" for="dualPrimaryDisabilityId">{{ t('manageEnrollment.addViewEditChild.fields.primaryDisability') }}</label>
                  @if (!isView) {
                    <mat-form-field appearance="fill" id="primaryDisabilitySelect" class="drdp-input">
                      <mat-select formControlName="dualPrimaryDisabilityId" [placeholder]="selectedDisability ?? t('manageEnrollment.addViewEditChild.fields.primaryDisability')"
                        (selectionChange)="handlePrimaryDisability($event)">
                        <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                        @for (disability of disabilities; track disability) {
                          <mat-option [value]="disability">
                            {{ disability.primaryDisabilityName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <p class="text-sm">{{ childData?.dualPrimaryDisabilityName }}</p>
                    </div>
                  }
                </div>
              }
              @if (primaryDisabilityReq) {
                <div>
                  @if ((!isView && hasFollowUp)) {
                    <div>
                      <div class="col-span-1 col-end-3">
                        <label class="font-normal" for="dualExtensiveSupportId">{{ t('manageEnrollment.addViewEditChild.fields.extensiveSupportNeeds') }}</label>
                        <mat-radio-group [attr.aria-label]="t('manageEnrollment.addViewEditChild.common.selectAnOption')" formControlName="dualExtensiveSupportId">
                          <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                          @for (es of extensiveSupports; track es) {
                            <mat-radio-button color="primary" [value]="es.id">
                              {{ es.extensiveSupportOption }}
                            </mat-radio-button>
                          }
                          @if (dualExtensiveSupportId.touched && dualExtensiveSupportId.invalid) {
                            <mat-error>{{ required }}</mat-error>
                          }
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isView && hasFollowUp) {
                    <div class="form-input-label-group">
                      <div class="col-span-1 col-end-3">
                        <label class="font-normal" for="firstName">{{ t('manageEnrollment.addViewEditChild.fields.extensiveSupportNeeds') }}</label>
                        <div class="bg-white removeLine" appearance="fill">
                          <p class="text-small">{{ childData?.extensiveSupportOption }}</p>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isDistrictLiabilityEnabled) {
                <div class="form-input-label-group">
                  <label class="font-normal" for="dualDistrictOfLiabilityId"
                  [ngClass]="{'required': dualIepPlanId.value == iepPlan.Yes}">{{ t('manageEnrollment.addViewEditChild.fields.districtOfLiability') }}</label>
                  @if (!isView) {
                    <mat-form-field appearance="fill" id="liabilitySelect" class="drdp-input">
                      <mat-select formControlName="dualDistrictOfLiabilityId" [placeholder]="t('manageEnrollment.addViewEditChild.fields.districtOfLiability')">
                        <!-- Server-supplied lookup values: localized by the API, not by Transloco. -->
                        @for (dol of districtsOfLiability; track dol) {
                          <mat-option [value]="dol.id">
                            {{ dol.districtOfLiabilityName }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (dualDistrictOfLiabilityId.invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <p>{{ childData?.dualDistrictOfLiabilityName }}</p>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isDistrictLiabilityEnabled) {
                <div class="form-input-label-group">
                  <label class="font-normal">{{ t('manageEnrollment.addViewEditChild.fields.districtId') }}</label>
                  <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                    <input matInput type="text" [value]="dualDistrictId" [readonly]="true" />
                  </mat-form-field>
                </div>
              }
              @if (specialEdInfo.isDistrictLiabilityEnabled) {
                <div class="form-input-label-group">
                  <label class="font-normal">{{ t('manageEnrollment.addViewEditChild.fields.sauId') }}</label>
                  <mat-form-field class="bg-white" [ngClass]="{ removeLine: isView }" appearance="fill">
                    <input matInput type="text" [value]="dualSauId" readonly="true" />
                  </mat-form-field>
                </div>
              }
              @if (specialEdInfo.isSpecialEdEntryEnabled) {
                <div class="form-input-label-group">
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="dualSeEntryDate">{{ t('manageEnrollment.addViewEditChild.fields.specialEdEntryDate') }}</label>
                      <p class="text-sm">
                        {{ dualSeEntryDate?.value | localizedDate: "MM/dd/yyyy" }}
                      </p>
                    </div>
                  }
                  @if (!isView) {
                    <div>
                      <drdp-date-picker [label]="t('manageEnrollment.addViewEditChild.fields.specialEdEntryDate')" [initialDate]="dualSeEntryDate?.value"
                        [isReadOnly]="isView" [isRequired]="false" labelClasses="pb-10 mb-5"
                        (emitDate)="handleDate($event, 'dualSeEntryDate')">
                      </drdp-date-picker>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isAnticipatedDateEnabled) {
                <div class="form-input-label-group">
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="dualSeAnticipateExitDate">{{ t('manageEnrollment.addViewEditChild.fields.specialEdAnticipatedExitDate') }}</label>
                      <p class="text-sm">
                        {{ dualSeAnticipateExitDate?.value | localizedDate: "MM/dd/yyyy" }}
                      </p>
                    </div>
                  }
                  @if (!isView) {
                    <div>
                      <drdp-date-picker [label]="t('manageEnrollment.addViewEditChild.fields.specialEdAnticipatedExitDate')"
                        [initialDate]="dualSeAnticipateExitDate?.value" [isReadOnly]="isView" [isRequired]="false"
                        labelClasses="pb-5 mb-5" (emitDate)="handleDate($event, 'dualSeAnticipateExitDate')">
                      </drdp-date-picker>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isInitialAssessmentToolEnabled) {
                <div class="form-input-label-group">
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="dualInitialAssessmentToolId">{{ t('manageEnrollment.addViewEditChild.fields.initialAssessmentTool') }}</label>
                      <p class="text-sm">{{ dualInitialAssessmentToolId.value }}</p>
                    </div>
                  }
                  @if (!isView) {
                    <div>
                      <drdp-select-initial-assessment-tool-type [label]="t('manageEnrollment.addViewEditChild.fields.initialAssessmentTool')"
                        [initialId]="dualInitialAssessmentToolId?.value"
                        (optionSelected)="handleInitAssessment($event, 'dualInitialAssessmentToolId')">
                      </drdp-select-initial-assessment-tool-type>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isOutcome1Enabled) {
                <div class="form-input-label-group">
                  @if (!isView) {
                    <div>
                      <drdp-select-outcome [label]="t('manageEnrollment.addViewEditChild.fields.outcome1')" [initialId]="dualOutcome1Id?.value"
                        (optionSelected)="handleOutcome($event, 'dualOutcome1Id')">
                      </drdp-select-outcome>
                    </div>
                  }
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="dualOutcome1Id">{{ t('manageEnrollment.addViewEditChild.fields.outcome1') }}</label>
                      <p class="text-sm">{{ dualOutcome1Id.value }}</p>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isOutcome2Enabled) {
                <div class="form-input-label-group">
                  @if (!isView) {
                    <div>
                      <drdp-select-outcome [label]="t('manageEnrollment.addViewEditChild.fields.outcome2')" [initialId]="dualOutcome2Id?.value"
                        (optionSelected)="handleOutcome($event, 'dualOutcome2Id')">
                      </drdp-select-outcome>
                    </div>
                  }
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="dualOutcome2Id">{{ t('manageEnrollment.addViewEditChild.fields.outcome2') }}</label>
                      <p class="text-sm">{{ dualOutcome2Id.value }}</p>
                    </div>
                  }
                </div>
              }
              @if (specialEdInfo.isOutcome3Enabled) {
                <div class="form-input-label-group">
                  @if (!isView) {
                    <div>
                      <drdp-select-outcome [label]="t('manageEnrollment.addViewEditChild.fields.outcome3')" [initialId]="dualOutcome3Id?.value"
                        (optionSelected)="handleOutcome($event, 'dualOutcome3Id')">
                      </drdp-select-outcome>
                    </div>
                  }
                  @if (isView) {
                    <div class="bg-white removeLine" appearance="fill">
                      <label class="font-normal" for="dualOutcome3Id">{{ t('manageEnrollment.addViewEditChild.fields.outcome3') }}</label>
                      <p class="text-sm">{{ dualOutcome3Id.value }}</p>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 pt-4 md:pt-8">
            <!-- State-configured demographic fields: labels and options are server-supplied. -->
            @for (custom of customStateConfig | groupDemographicSection : demographicSections.specialEdInfo; track custom) {
              <div class="form-input-label-group"
                >
                @if (isView) {
                  <div [id]="custom.label" class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" ngClass="removeLine" appearance="fill">
                      <input matInput [readonly]="true" autocomplete="off" [formControlName]="custom.label" maxlength="10" />
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownSingle && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                    (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )">
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.dropdownMultiple && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field appearance="fill" class="drdp-input">
                      <mat-select [formControlName]="custom.label" [placeholder]="t('manageEnrollment.addViewEditChild.placeholders.select')"
                  (selectionChange)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" multiple>
                        @for (option of custom.options | option : '|'; track option) {
                          <mat-option [value]="option">
                            {{ option }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.text && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="text" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.number && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <label class="font-normal" [ngClass]="{ required: custom.isRequired }" [for]="custom.label">
                    {{ custom.label }}</label>
                    <mat-form-field class="bg-white" appearance="fill">
                      <input placeholder="" matInput type="number" [formControlName]="custom.label"
                        [maxlength]="custom.maxLength"
                    (input)="
                      buildCustomConfigObj(
                        custom.label,
                        custom.id,
                        custom.customFieldTypeId
                      )" />
                      @if (addChildForm.controls[custom.label].invalid) {
                        <mat-error>{{ required }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (custom.customFieldTypeId === fieldType.date && !isView) {
                  <div [id]="custom.label"
                    class="form-input-label-group">
                    <drdp-date-picker [label]="custom.label" [initialDate]="addChildForm.get(custom.label)?.value"
                      [isReadOnly]="isView" [isRequired]="custom.isRequired"
                  (emitDate)="
                    buildCustomConfigObj(
                      custom.label,
                      custom.id,
                      custom.customFieldTypeId,
                      $event
                    )">
                    </drdp-date-picker>
                  </div>
                }
              </div>
            }
          </div>
          @if (!isView) {
            <hr />
          }
          @if (!isView) {
            <div class="mt-10 mb-2 flex justify-end">
              <drdp-btn class="pr-4" (click)="resetAddChildForm()" color="cancel">
                {{ t('manageEnrollment.addViewEditChild.actions.cancel') }}
              </drdp-btn>
              <drdp-btn (click)="handleSubmit($event)" [disabled]="!addChildForm.valid" cdkFocusInitial>
                {{ submitBtnLabel }}
              </drdp-btn>
            </div>
          }
        </form>
      </drdp-container>
    }
  </div>
</ng-container>
